export const Permissions = Object.freeze({
	Grids: {
		View: 'Grids/View',
		Edit: 'Grids/Edit',
		BulkEdit: 'Grids/BulkEdit',
		BulkRestore: 'Grids/BulkRestore',
		Add: 'Grids/Add',
		Delete: 'Grids/Delete',
		ViewDeletedEntries: 'Grids/ViewDeletedEntries',
		Merge: 'Grids/Merge',
		CreateGlobalGridView: 'Grids/CreateGlobalGridView',
	},
	Inventory: {
		View: 'Inventory/View',
		BulkEdit: 'Inventory/BulkEdit',
		CreateGlobalGridView: 'Inventory/CreateGlobalGridView',
	},
	Activity: {
		View: 'Activity/View',
	},
	Reports: {
		View: 'Reports/View',
	},
	Tools: {
		ProjectClone: {
			View: 'Tools/ProjectClone/View',
		},
		FormBuilder: {
			View: 'Tools/FormBuilder/View',
			Add: 'Tools/FormBuilder/Add',
			Edit: 'Tools/FormBuilder/Edit',
			Delete: 'Tools/FormBuilder/Delete',
			Clone: 'Tools/FormBuilder/Clone',

			Fields: {
				View: 'Tools/FormBuilder/Fields/View',
				Add: 'Tools/FormBuilder/Fields/Add',
				Edit: 'Tools/FormBuilder/Fields/Edit',
				Delete: 'Tools/FormBuilder/Fields/Delete',
			},
			Interactions: {
				View: 'Tools/FormBuilder/Interactions/View',
				Add: 'Tools/FormBuilder/Interactions/Add',
				Edit: 'Tools/FormBuilder/Interactions/Edit',
				Delete: 'Tools/FormBuilder/Interactions/Delete',
			},
			AssignUser: {
				View: 'Tools/FormBuilder/AssignUser/View',
				Edit: 'Tools/FormBuilder/AssignUser/Edit',
			},
			Filters: {
				View: 'Tools/FormBuilder/Filters/View',
				Add: 'Tools/FormBuilder/Filters/Add',
				Edit: 'Tools/FormBuilder/Filters/Edit',
				Delete: 'Tools/FormBuilder/Filters/Delete',
			},
		},
		ActivityBuilder: {
			View: 'Tools/ActivityBuilder/View',
			Add: 'Tools/ActivityBuilder/Add',
			Edit: 'Tools/ActivityBuilder/Edit',
			Delete: 'Tools/ActivityBuilder/Delete',
			Clone: 'Tools/ActivityBuilder/Clone',

			StaticFields: {
				View: 'Tools/ActivityBuilder/StaticFields/View',
				Add: 'Tools/ActivityBuilder/StaticFields/Add',
				Edit: 'Tools/ActivityBuilder/StaticFields/Edit',
				Delete: 'Tools/ActivityBuilder/StaticFields/Delete',
			},
			ComputedFields: {
				View: 'Tools/ActivityBuilder/ComputedFields/View',
				Add: 'Tools/ActivityBuilder/ComputedFields/Add',
				Edit: 'Tools/ActivityBuilder/ComputedFields/Edit',
				Delete: 'Tools/ActivityBuilder/ComputedFields/Delete',
			},
			Items: {
				View: 'Tools/ActivityBuilder/Items/View',
				Add: 'Tools/ActivityBuilder/Items/Add',
				Edit: 'Tools/ActivityBuilder/Items/Edit',
				Delete: 'Tools/ActivityBuilder/Items/Delete',
			},
			Filters: {
				View: 'Tools/ActivityBuilder/Filters/View',
				Add: 'Tools/ActivityBuilder/Filters/Add',
				Edit: 'Tools/ActivityBuilder/Filters/Edit',
				Delete: 'Tools/ActivityBuilder/Filters/Delete',
			},
		},
		ReportBuilder: {
			Report: {
				View: 'Tools/ReportBuilder/Report/View',
				Add: 'Tools/ReportBuilder/Report/Add',
				Edit: 'Tools/ReportBuilder/Report/Edit',
				Delete: 'Tools/ReportBuilder/Report/Delete',
				Clone: 'Tools/ReportBuilder/Report/Clone',
				AssignUser: {
					View: 'Tools/ReportBuilder/AssignUser/View',
					Edit: 'Tools/ReportBuilder/AssignUser/Edit',
				},
			},
			Workbook: {
				View: 'Tools/ReportBuilder/Workbook/View',
				Add: 'Tools/ReportBuilder/Workbook/Add',
				Edit: 'Tools/ReportBuilder/Workbook/Edit',
				Delete: 'Tools/ReportBuilder/Workbook/Delete',
				Clone: 'Tools/ReportBuilder/Workbook/Clone',
			},
		},

		DataImport: {
			View: 'Tools/DataImport/View',
			Upload: 'Tools/DataImport/Upload',
			Templates: {
				View: 'Tools/DataImport/Templates/View',
				Add: 'Tools/DataImport/Templates/Add',
				Edit: 'Tools/DataImport/Templates/Edit',
				Delete: 'Tools/DataImport/Templates/Delete',
				TemplateFields: {
					View: 'Tools/DataImport/Templates/TemplateFields/View',
					Add: 'Tools/DataImport/Templates/TemplateFields/Add',
					Edit: 'Tools/DataImport/Templates/TemplateFields/Edit',
					Delete: 'Tools/DataImport/Templates/TemplateFields/Delete',
				},
			},
		},
		DataExport: {
			View: 'Tools/DataExport/View',
		},
		UserManagement: {
			View: 'Tools/ClientUserManagement/View',
			Add: 'Tools/ClientUserManagement/Add',
			Edit: 'Tools/ClientUserManagement/Edit',
			Delete: 'Tools/ClientUserManagement/Delete',
			AssignToProject: 'Tools/ClientUserManagement/AssignToProject',
			EditPermissions: 'Tools/ClientUserManagement/EditPermissions',
		},
	},

	ProjectManagement: {
		Add: 'ProjectManagement/Add',
		Edit: 'ProjectManagement/Edit',
		View: 'ProjectManagement/View',
		Delete: 'ProjectManagement/Delete',
		CanViewOdataUrl: 'ProjectManagement/CanViewOdataUrl',
		CanViewSwaggerUrl: 'ProjectManagement/CanViewSwaggerUrl',
		CanViewProjectId: 'ProjectManagement/CanViewProjectId',
		ManageMobileAccess: 'ProjectManagement/ManageMobileAccess',
	},
	Settings: {
		View: 'Settings/View',
		GeneralSettings: {
			View: 'Settings/GeneralSettings/View',
		},
		DataFields: {
			View: 'Settings/DataFields/View',
			Add: 'Settings/DataFields/Add',
			Edit: 'Settings/DataFields/Edit',
		},
		ReferenceLists: {
			View: 'Settings/ReferenceLists/View',
			ReferenceType: {
				Add: 'Settings/ReferenceLists/ReferenceType/Add',
				Edit: 'Settings/ReferenceLists/ReferenceType/Edit',
				Delete: 'Settings/ReferenceLists/ReferenceType/Delete',
			},
			ReferenceValues: {
				Add: 'Settings/ReferenceLists/ReferenceValues/Add',
				Edit: 'Settings/ReferenceLists/ReferenceValues/Edit',
				Delete: 'Settings/ReferenceLists/ReferenceValues/Delete',
			},
		},
		Permissions: {
			View: 'Settings/Permissions/View',
			PermissionsGroups: {
				Add: 'Settings/Permissions/PermissionsGroup/Add',
				Edit: 'Settings/Permissions/PermissionsGroup/Edit',
				Delete: 'Settings/Permissions/PermissionsGroup/Delete',
			},
		},
		GridFields: {
			View: 'Settings/GridFields/View',
			Add: 'Settings/GridFields/Add',
			Edit: 'Settings/GridFields/Edit',
			Delete: 'Settings/GridFields/Delete',
		},
		Connectors: {
			View: 'Settings/Connectors/View',
			Add: 'Settings/Connectors/Add',
			Edit: 'Settings/Connectors/Edit',
			Delete: 'Settings/Connectors/Delete',
		},
		MergeConditions: {
			Add: 'Settings/MergeCondition/Add',
			View: 'Settings/MergeCondition/View',
			Delete: 'Settings/MergeCondition/Delete',
		},
	},
});
